/* eslint-disable no-shadow */
export enum TodoType {
  /** 病院紹介希望条件 */
  HospitalCondition = 'hospitalCondition',

  /** 病院紹介リスト */
  HospitalIntroduction = 'hospitalIntroduction',

  /** 問診 */
  Questionnaire = 'inquiry',

  /** 基本問診 */
  WelcomeQuestionnaire = 'welcomeInquiry',

  /** オンライン医療相談 */
  VideoMeeting = 'videoMeeting',

  /** オンライン医療相談（有料） */
  MedicalConsultationCharged = 'medicalConsultationCharged',

  /** オンライン診療 */
  Telemedicine = 'medicalDiagnosis',

  /** 請求カード */
  Invoice = 'payment',

  /** チャット医療相談 */
  SpecialistChat = 'specialistChat',
}

export const TodoTypeReverse = Object.fromEntries(
  Object.entries(TodoType).map(([key, value]) => [value, key]),
);

export enum TodoTypeLabel {
  HospitalCondition = '病院紹介希望条件',

  HospitalIntroduction = '病院紹介',

  Questionnaire = '問診',

  WelcomeQuestionnaire = 'コンディションサーベイ',

  VideoMeeting = 'オンライン医療相談',

  MedicalConsultationCharged = 'オンライン医療相談（有料）',

  Telemedicine = 'オンライン診療',

  Invoice = '請求',

  SpecialistChat = 'チャット医療相談',
}

export enum TodoStatus {
  /** [patient] [病院紹介希望条件, 問診] 回答タスク */
  Answer = 'answer',

  /** [doctor] [病院紹介希望条件, 問診] 回答待ち */
  Waiting = 'waiting',

  /** [patient, doctor] [病院紹介リスト, 問診] 回答確認タスク */
  Confirm = 'confirm',

  /** [patient] [病院紹介希望条件] 病院紹介待ち */
  IntoductionWaiting = 'intoductionWaiting',

  /** [doctor] [病院紹介希望条件] 病院紹介タスク */
  Introduction = 'introduction',

  /** [patient, doctor] [オンライン医療相談] 予約済み */
  Reserved = 'reserved',
}

export const TodoStatusReverse = Object.fromEntries(
  Object.entries(TodoStatus).map(([key, value]) => [value, key]),
);

export enum TodoStatusLabel {
  Answer = 'が届きました。',

  Waiting = 'の回答を待っています。',

  Confirm = 'の回答が届きました。',

  IntoductionWaiting = 'を待っています。',

  Introduction = 'が届きました。',

  Reserved = 'の予定があります。',
}
/* eslint-enable */

// 旧名'定期基本問診'も残すのは、改称前に作られたBEのデータが残っているため。
export const CONDITION_SURVEY_TITLES: readonly string[] = [
  TodoTypeLabel.WelcomeQuestionnaire,
  '定期基本問診',
];

export const isConditionSurveyTitle = (title: string | undefined | null): boolean => {
  return !!title && CONDITION_SURVEY_TITLES.some((name) => title.startsWith(name));
};

// 生活習慣ケアは提供終了。BEが過去分の付箋を返し続けるため、レーンに載せない。
export const DISCONTINUED_PROJECT_TYPES: readonly string[] = ['lifeStyle'];

export const isDiscontinuedProjectType = (projectType: string | undefined | null): boolean => {
  return !!projectType && DISCONTINUED_PROJECT_TYPES.includes(projectType);
};

// 改称前に配信されたデータはタイトルが旧名のままBEから返るため、表示の直前に読み替える。
// 保存・送信する値は旧名のままにしないとBEの既存データと突き合わせられなくなる。
export const toConditionSurveyDisplayText = (title: string | undefined | null): string => {
  return (title || '').replace(/定期基本問診/g, TodoTypeLabel.WelcomeQuestionnaire);
};
